<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item v-if="formValidate.protection_status === 1 && formValidate.is_pay === 1" label="审核状态：" prop="protection_status">
              <el-radio-group v-model="subData.protection_status" >
                <el-radio :label="2">通过</el-radio>
                <el-radio :label="-1">拒绝</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="formValidate.protection_status == 2" label="维权是否完成：" prop="protection_status">
              <el-radio-group v-model="subData.protection_status">
                <el-radio :label="3">维权完成</el-radio>
                <el-radio :label="0">维权未完成</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item v-if="subData.protection_status == 3" label="维权结果：" prop="protection_results">
              <el-radio-group v-model="subData.protection_results">
                <el-radio :label="1">维权成功</el-radio>
                <el-radio :label="2">维权失败</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="状态流程：">
              <el-table
                :data="data"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column align="center" prop="protection_title" label="ID" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.protection_status_id" class="priceBox" readonly/>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="protection_title" label="标题" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.protection_title" class="priceBox"/>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="protection_desc" label="详情" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.protection_desc" class="priceBox"/>
                  </template>
                </el-table-column>
                <el-table-column align="center" prop="protection_imgs" label="图片" min-width="200">
                  <template slot-scope="scope">
                    <div class="acea-row">
                      <div
                        v-for="(item, index) in scope.row.protection_imgs"
                        :key="index"
                        class="pictrue"
                        draggable="false"
                        @dragstart="handleDragStart($event, item, scope.$index)"
                        @dragover.prevent="handleDragOver($event, item,scope.$index)"
                        @dragenter="handleDragEnter($event, item,scope.$index)"
                        @dragend="handleDragEnd($event, item, scope.$index)"
                      >
                        <img :src="item">
                        <i
                          class="el-icon-error btndel"
                          @click="handleRemove(index,scope.$index)"
                        />
                      </div>
                      <div
                        v-if="scope.row.protection_imgs.length < 10"
                        class="uploadCont"
                        title="750*750px"
                      >
                        <div class="upLoadPicBox" @click="modalPicTap('2',scope.$index)">
                          <div class="upLoad">
                            <i class="el-icon-camera cameraIconfont" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                    <el-button type="text" class="submission" @click="delSpecs(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onAdd">添加参数</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import { roterPre } from '@/settings'
import {
  appraisalCateDetailApi,
  appraisalPersonDetailApi,
  saveAppraisalCateDataApi,
  saveAppraisalPersonDataApi
} from "@/api/appraisal";
import {protectionStatusDetailApi, saveProtectionStatusDataApi} from "@/api/protection";
const defaultObj = {
  cate_name: '',
  cate_image: '',
  cate_value: [],
}
export default {
  name: 'addCate',
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      progress: 0,
      data: [],
      subData: {
        protection_status: 0,
        protection_results: 0
      }
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.getProtectionStatusData()
    }

  },
  methods: {
    onAdd() {
      let obj = { protection_status_id: "", protection_title:"",protection_desc:"",protection_imgs:[]};
      this.data.push(obj);
    },
    // 删除
    delSpecs(idx) {
      this.data.splice(idx, 1);
    },
    // 点击图
    // 点击图
    modalPicTap(tit, i) {
      const _this = this;
      this.$modalUpload(function(img) {
        if (tit === "2") {
          img.map(item => {
            _this.data[i].protection_imgs.push(item);
          });
        }
      }, tit);
    },
    // 移动
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move";
    },
    handleDragEnter(e, item,i) {
      e.dataTransfer.effectAllowed = "move";
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.data[i].protection_imgs];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.data[i].protection_imgs = newItems;
    },
    handleRemove(i,index) {
      this.data[index].protection_imgs.splice(i, 1);
    },
    // 获取数据
    getProtectionStatusData() {
      this.fullscreenLoading = true
      protectionStatusDetailApi(this.$route.params.id)
        .then(res => {
          this.formValidate =  res.data
          this.subData.protection_status = res.data.protection_status
          this.subData.protection_results = res.data.protection_results
          this.data  =  res.data.statusList
          this.fullscreenLoading = false
          this.loading = false
          console.log(this.data);
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      this.subData.status_detail = this.data;
      this.subData.protection_id = this.$route.params.id;
      console.log(this.subData);
      saveProtectionStatusDataApi(this.subData)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/protection/list' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
